import { render, staticRenderFns } from "./ClientContactsPage.vue?vue&type=template&id=c85a3b28"
import script from "./ClientContactsPage.vue?vue&type=script&lang=js"
export * from "./ClientContactsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports